export function confirmDeleteRz_task_assignment(button) {
if (confirm('Вы уверены, что хотите удалить эту задачу?')) {
    new SendData({
        url: Redirect.route('removeRz_task_assignment'),
        data: Object.assign(getDataAll(button), {
            instructionPost: {
                find: {
                    performers: ['array_key_first']
                }
            }
        })
    }).then((response) => {
        MessageManager.processResponse(response);
        button.reload();
    });
}
}